import(/* webpackMode: "eager" */ "/home/runner/work/psx-frontend/psx-frontend/app/data/structure/page.tsx");
